export default __webpack_public_path__ + "static/media/P-2U-FRONT.48b9c6fb.png";